import { createTypedReducerWithImmer } from "@insite/client-framework/Common/CreateTypedReducer";
import ApplicationState from "@insite/client-framework/Store/ApplicationState";
import { AnyAction, reducers } from "@insite/client-framework/Store/Reducers";
import { Draft } from "immer";
interface SECustomState {
    widgetId: string;
}
const SECustomStateInitialState: SECustomState = {
    widgetId: "",
};

interface SEShipViaAccountNumberState {
    shipViaAccountNumber: string;
    filtersList: string[]
}
const initialState: SEShipViaAccountNumberState = {
    shipViaAccountNumber: "",
    filtersList: []
};

const SECustomStateInitialStateReducer = createTypedReducerWithImmer(SECustomStateInitialState, {
    "Custom/productCarouselId/set": (
        draft: Draft<SECustomState>,
        action: { widgetId: string },
    ) => {draft.widgetId = action.widgetId;}
});
const reducer = createTypedReducerWithImmer(initialState, {
    "Custom/CheckoutReviewAndSubmitCarrierService/UpdateShipViaAccountNumber": (
        draft: Draft<SEShipViaAccountNumberState>,
        action: { shipViaAccountNumber: string },
    ) => {draft.shipViaAccountNumber = action.shipViaAccountNumber;},
    'Custom/Immer/AddToProductsListFilters': (
        draft: Draft<SEShipViaAccountNumberState>,
        action: { filtersList: string[] },
    ) => {draft.filtersList = action.filtersList}
});

// export default createTypedReducerWithImmer(initialState, reducer);
(reducers as any).CustomShipViaAccountNumberReducer = reducer;
(reducers as any).ProductCarouselIdReducer = SECustomStateInitialStateReducer;

export type CustomShipViaAccountNumberState = {
    CustomShipViaAccountNumberReducer: SEShipViaAccountNumberState;
} & ApplicationState;
export type ProductCarouselIdState = {
    ProductCarouselIdReducer: SECustomState;
} & ApplicationState;

type Reducers = {
    CustomShipViaAccountNumberReducer: typeof reducer;
};
type SECustomStateReducer = {
    ProductCarouselIdReducer: typeof SECustomStateInitialStateReducer;
};

export type CustomShipViaAccountNumberActions = Parameters<Reducers[keyof Reducers]>[1] | AnyAction;
export type ProductCarouselIdAction = Parameters<SECustomStateReducer[keyof SECustomStateReducer]>[1] | AnyAction;
